import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 create_tenant_order_dispatch: { message: "idle" },
};

export const create_tenant_order_dispatch_Slice = createSlice({
 name: "create_tenant_order_dispatch",
 initialState,
 reducers: {
  success_create_tenant_order_dispatch: (state, action) => {
   state.create_tenant_order_dispatch = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_create_tenant_order_dispatch: (state, action) => {
   state.create_tenant_order_dispatch = { status: app_consts.FAIL, message: action.payload };
  },
  reset_create_tenant_order_dispatch: (state) => {
   state.create_tenant_order_dispatch = { status: app_consts.IDLE };
  },
  loading_create_tenant_order_dispatch: (state) => {
   state.create_tenant_order_dispatch = { status: app_consts.LOADING };
  },
 }
});

export const { success_create_tenant_order_dispatch, fail_create_tenant_order_dispatch, reset_create_tenant_order_dispatch, loading_create_tenant_order_dispatch } = create_tenant_order_dispatch_Slice.actions;

export default create_tenant_order_dispatch_Slice.reducer;